import { createTheme, mergeThemes } from "@animech/ui";
import { theme as piabTheme } from "@animech/piab-theme";
import { componentsTheme } from "./components";
var piabVATheme = mergeThemes(piabTheme, componentsTheme);
export var theme = createTheme(piabVATheme);
